import { ModalRoot } from './ModalRoot';
import { ModalHeader } from './ModalHeader';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { ModalActions } from './ModalActions';
import BaseModalComponent from './BaseModal';

// default export for backward compatibility
export default BaseModalComponent;

// compound component namespace
// eslint-disable-next-line react-refresh/only-export-components
export const Modal = {
  Root: ModalRoot,
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
  Actions: ModalActions,
};

// re-export for explicit imports
export { default as BaseModal } from './BaseModal';
